import { createSvgIconComponent } from "../utils";
export var IconTwitter = createSvgIconComponent({
  viewBox: "0 0 24 24",
  paths: [{
    d: "M14.5,10.3l8-9.2h-3.7l-6.1,6.9L7.6,1.2H0L9.1,13l-8.6,9.8h3.7l6.6-7.6l5.8,7.6H24L14.5,10.3z M4.3,3.2h2.2l13.2,17.4h-2L4.3,3.2z"
  }]
});